import { render, staticRenderFns } from "./RingLoader.vue?vue&type=template&id=6569d87a&scoped=true&"
import script from "./RingLoader.vue?vue&type=script&lang=js&"
export * from "./RingLoader.vue?vue&type=script&lang=js&"
import style0 from "./RingLoader.vue?vue&type=style&index=0&id=6569d87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569d87a",
  null
  
)

export default component.exports